// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1WE2w","title":"ClientReferral_title__NJ1va","itemText":"ClientReferral_itemText__PQxRl"};